import { IAward } from '../../../../../store/admin/eventAwards/store';

export const blankAward: IAward = {
  cash: 0,
  hole: null,
  id: -1,
  note: '',
  points: 0,
  scrip: 0,
  team: null,
  touched: {},
  type: '',
  user: -1
};
